<template>
<div class="chapter">
<div class="inner_page">
<p class="prect" id="how"><a id="p9"></a><a href="#/005Contents#how-">HOW TO USE <br/>THIS BOOK</a></p>
<p class="ftxt"><span class="dropcaps"><b>T</b></span>his book is easily navigable as it’s split into easy-to-access sections starting with the <b>Survivor’s Mindset</b>. Before we do anything, we need to become accustomed to the mental state that is needed to survive and thrive. Once we’ve mastered this mindset, we move onto the <b>Essentials</b>, which details how to plan ahead, the kit and skills you’ll need to acquire, how to stay warm and dry, and administer first aid. The obstacles to survive have been split up in <a href="#/011Part_03#part3"><b>Part Three</b></a> as we discuss <b>Climate and Terrain</b>, which explores the dangers caused by the earth itself. Following this is <b>Personal Crises</b>, which looks at how to deal with things which can suddenly turn our lives upside down, like the loss of a loved one, addiction or job loss. <a href="#/013Part_05#part5"><b>Part Five</b></a> discusses <b>Aggression</b>, looking at attacks to your person, be it from a wild animal or a human. Finally, there’s the <b>Breakdown of Society</b>, which is caused by people and encompasses anything from a biochemical attack to a nuclear war.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008-How_to_Use.vue?1e80daa7